import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import { AlertController } from 'ionic-angular';
import {MyvariableService} from '../home/constantvariable';
import {MycartPage} from '../mycart/mycart';
import { LoadingController } from 'ionic-angular';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloStorePage} from "../kilostore/kilostore";

@Component({
	selector: 'page-product',
	templateUrl: 'product.html',
	providers:[MydataService,MyUrlService,JsonData,Device,MyvariableService]
})
export class ProductPage implements OnInit{
	jsonDt : Array<JsonData>;
	productdetailDt: Array<JsonData>;
	myParseInt = parseInt;
	pcs = this.MyvariableService.PCS;
	itemPerPack = this.MyvariableService.ITEMPARPACK;
 tax = this.MyvariableService.TAX;
	
	quty = parseFloat(window.localStorage.getItem('orderQty'));
	minQty = parseFloat(window.localStorage.getItem('minQty'));
	maxQty = parseFloat(window.localStorage.getItem('maxQty'));
	increase = parseFloat(window.localStorage.getItem('increase'));
	image:Array<JsonData>;
	takeawayMinValue:any;
	minOrderValue:any;
	deliverych:any;
	constructor(public device: Device,public alerCtrl: AlertController,public loading: LoadingController,private http:Http,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService,public MyvariableService: MyvariableService) {
	}
	
	ngOnInit(){
		//alert('heloo');
		var productid = window.localStorage.getItem('proid');
		//console.log("product id -->"+productid);
		var categoryid = window.localStorage.getItem('localid');
		var session_ids=window.localStorage.getItem('session_ids');
		//console.log("menu cat id-->"+categoryid);
		var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"productid":productid,"categoryid":categoryid,"IMEI":session_ids});
		//console.log("Product Url--->"+this.myurlService.PRODUCTDETAILURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		let loader = this.loading.create({content: '',});
		
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.PRODUCTDETAILURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.productdetailService(loader));
			
		});
		
	}
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
	productdetailService=function(loader){
		//console.log("productdetail receive jsondata ==>"+JSON.stringify(this.jsonDt));
		this.productdetailDt = this.jsonDt.productdetaildata;
		this.image= this.myurlService.IMAGEURL;
		this.totalcountDt = this.jsonDt.totalcount;
		this.totalcount = this.totalcountDt[0].totalcounts;
		this.ASSISTANCECALL= this.MyvariableService.ASSISTANCECALL;
		this.MINHOUR= this.MyvariableService.MINHOUR;
		this.FREEDELIVERY= this.MyvariableService.FREEDELIVERY;
		this.deliverytimes = window.localStorage.getItem('deliverytimes');
				this.productdeliveryhoursdata = this.jsonDt.productdeliveryhoursdata;

		//console.log("productdetaildata ==>"+JSON.stringify(this.jsonDt.productdetaildata));
		////console.log("subcategorydata ==>"+JSON.stringify(this.jsonDt.subcategorydata))
		////console.log("namedata ==>"+JSON.stringify(this.jsonDt.namedata));
		////console.log("mobilenodata ==>"+JSON.stringify(this.jsonDt.mobilenodata));
		////console.log("func post ---->"+this.postData);
		this.kiloPointCheck();
		loader.dismiss();
	}
	kiloPointCheck=function(){
		var userid = window.localStorage.getItem('userid');
		var kiloSabjiJSONdata = JSON.stringify({'userid': userid});
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.USERADDRESS, kiloSabjiJSONdata).subscribe(data => this.jsonDt = data, error => this.errorFunction(loader,error), () => this.productShow(loader));
		});
	}
	
	productShow=function(loader){
		loader.dismiss();
		//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt));
		this.minOrderValue = this.jsonDt.orderconfig[0].minOrderValue;
			this.deliverych	 = this.jsonDt.orderconfig[0].deliverycharge;
			this.takeawayMinValue = this.jsonDt.orderconfig[0].takeawayMinValue;
		
	}
	addItem()
	{
	
	if(window.localStorage.getItem('localid')=="1"){
		if(0<this.quty) {
			this.quty = this.quty + this.increase;
		}
		}else{
		if(this.quty<this.maxQty) {
			this.quty = this.quty + this.increase;
		}
		
		}
		}
		
		removeItem()
		{
			if(this.quty>this.minQty){
				this.quty=this.quty-this.increase;
			}
		}
		
		addcart(parent_id,cartid,proid,price,totalamt,quty)
		{
			//console.log('Device UUID is: ' + this.device.uuid);
			var session_ids=window.localStorage.getItem('session_ids');
			//alert("hello IMEI--->"+this.device.uuid);
			var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"categoryid":cartid,"productid":proid,"multidata":[],"price":price,"totalamt":totalamt,"IMEI":session_ids,"qty":quty});
			//console.log("Product Url--->"+this.myurlService.ADDTOCARTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.ADDTOCARTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.addCrtservice(loader,parent_id));
			});
			
		}
		
		addCrtservice=function(loader,parent_id){
			//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
			this.addtocartDt = this.jsonDt.msg;
			this.totalcountDt = this.jsonDt.totalcount;
			this.totalcount = this.totalcountDt[0].totalcounts;
			//this.subcategorydataDt= this.jsonDt.subcategorydata;
			//this.image= this.myurlService.IMAGEURL;
			//console.log("cartdata ==>"+JSON.stringify(this.jsonDt.msg));
			loader.dismiss();
			window.localStorage.setItem('localid',parent_id);
			if(this.addtocartDt=='Exist'){
				this.addcartalert= this.MyvariableService.EXISTPRODUCT;
				this.showAlert(parent_id);
				}else{
				this.addcartalert= this.MyvariableService.ADDPRODUCT;
				this.showAlert(parent_id);
			}
		}
		
		showAlert=function(parent_id) {
			let alert = this.alerCtrl.create({
				// title: 'New Friend!',
				subTitle: this.addcartalert,
				buttons: [ {
					text: 'Ok',
					handler: data => {
						if(parent_id =="1"){
							this.navCtrl.setRoot(KiloMenuPage);
						}
						else{
							this.navCtrl.setRoot(KiloStorePage);	
						}
					}
				}
				]
				
			});
			alert.present();
		}
		
		mycart()
		{this.navCtrl.push(MycartPage)}
		
}



// WEBPACK FOOTER //
// ./src/pages/product/product.ts